const selectCohortData = (state) => state.cache.adebifyLtvCohort.data;
const selectCohorts = (state) => state.cache.adebifyLtvCohort.data.cohorts;
const selectAverageRow = (state) => state.cache.adebifyLtvCohort.data.averageRow;
const selectMeta = (state) => state.cache.adebifyLtvCohort.meta;
const selectSettings = (state) => state.cache.adebifyLtvCohort.settings;
const selectCumulativeMode = (state) => state.cache.adebifyLtvCohort.settings.cumulativeMode;
const selectMetric = (state) => state.cache.adebifyLtvCohort.settings.metric;
const selectAxis = (state) => state.cache.adebifyLtvCohort.settings.axis;
const selectFilters = (state) => state.cache.adebifyLtvCohort.settings.filters;
const selectStatus = (state) => state.cache.adebifyLtvCohort.status;
const selectError = (state) => state.cache.adebifyLtvCohort.error;

export {
  selectCohortData,
  selectCohorts,
  selectAverageRow,
  selectMeta,
  selectSettings,
  selectCumulativeMode,
  selectMetric,
  selectAxis,
  selectFilters,
  selectStatus,
  selectError,
};
